import React from 'react';
import { RefreshCw, X } from 'lucide-react';

interface UpdateNotificationProps {
  onDismiss: () => void;
}

export function UpdateNotification({ onDismiss }: UpdateNotificationProps) {
  return (
    <div className="bg-amber-50 dark:bg-amber-900/30 px-4 py-2 shadow-sm">
      <div className="flex items-center justify-between gap-4 mx-auto max-w-7xl">
        <div className="flex items-center gap-2">
          <RefreshCw className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          <p className="text-sm text-amber-700 dark:text-amber-300">
            A new version is available. Please sign out and sign in again to update.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onDismiss}
            className="text-amber-600 hover:text-amber-700 dark:text-amber-400 dark:hover:text-amber-300"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}